import { DateTimePicker } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { formatDate } from '@hero/utils';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 4px;
  margin-top: 4px;
  min-height: 40px;
  min-width: 140px;

  ${({ readOnly, isFocused }) => css`
    ${!readOnly && 'cursor: pointer;'}

    ${(!isFocused || readOnly) &&
    css`
      padding: 0 16px;
      &:hover {
        border-radius: var(--size-border-radius-md);
        outline: 1px solid var(--color-border-default);
      }
    `}
  `}
`;

export const ColumnDatePicker = ({
  onFocus,
  onChange,
  isFocused,
  readOnly,
  columnProps,
  error,
  onBlur,
  ...props
}) => {
  return (
    <Wrapper
      readOnly={readOnly}
      onClick={onFocus}
      isFocused={isFocused}
      error={error}
      columnProps={columnProps}
    >
      {!isFocused || readOnly ? (
        <>{props.value ? formatDate(props.value, { includeTime: false }) : <p>⎯</p>}</>
      ) : (
        <DateTimePicker
          error={error}
          onBlur={onBlur}
          onChange={val => {
            onChange(undefined, val);
          }}
          {...props}
        />
      )}
    </Wrapper>
  );
};
